/**
 * @module
 * control the behaviour of the mobile nav
 */

import helperMatomo from 'shared/mixins/helper-matomo';

const selector = '[data-js-nav-mobile-2]';
const navMobile2 = function (el, app) {

    const $el = $(el);
    const $html = $('html');
    const matomo = helperMatomo(app);

    let status = false;

    const init = function () {
        registerToggle();
    };

    // wax on, wax off.
    const registerToggle = function () {

        const $toggleLabel = $('[data-js-nav-icon-label]');
        const toOpenText = $el.text().trim();
        const toCloseText = $toggleLabel.attr('data-nav-mobile-close-text');

        $el.click(function () {
            if (!status) {
                $html.addClass('Ge-Nav--mobile');
                $toggleLabel.text(toCloseText);
                status = true;
            } else {
                $html.removeClass('Ge-Nav--mobile');
                $toggleLabel.text(toOpenText);
                status = false;
            }
            $el.attr('aria-expanded', status);

            matomo.push({
                event: 'Menyklick',
                menytyp: 'mobilmeny',
                clickText: status ? 'hamburger_open' : 'hamburger_close',
            });
        });
    };
    return {
        init: init()
    };
};

navMobile2.selector = selector;
export default navMobile2;
